<template lang="pug">
.v-conditions.conditions(v-if="data" :id="data?.id")
	.conditions__items(v-if="data.items")
		.conditions__item(v-for="item in data.items")
			.conditions__content
				img.conditions__image(v-if="item.image" :src="item.image.src" :alt="item.image.alt")
				.conditions__title(v-if="item.title") {{item.title}}
			v-table.conditions__table(:propsData="item")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>